'use client';
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { GripVertical } from 'lucide-react';
import * as ResizablePrimitive from 'react-resizable-panels';
import { cn } from '../../lib/utils.js';
import { ResizablePanel, ResizablePanelGroup } from './primitives/resizable';
function ResizableHandle(_a) {
    var withHandle = _a.withHandle, className = _a.className, props = __rest(_a, ["withHandle", "className"]);
    return (<ResizablePrimitive.Separator data-slot="resizable-handle" className={cn('group bg-border ring-offset-background focus-visible:ring-ring relative flex w-px items-center justify-center select-none after:absolute after:inset-y-0 after:left-1/2 after:w-1 after:-translate-x-1/2 focus-visible:ring-1 focus-visible:outline-hidden aria-[orientation=horizontal]:h-px aria-[orientation=horizontal]:w-full aria-[orientation=horizontal]:after:left-0 aria-[orientation=horizontal]:after:h-1 aria-[orientation=horizontal]:after:w-full aria-[orientation=horizontal]:after:translate-x-0 aria-[orientation=horizontal]:after:-translate-y-1/2 [&[aria-orientation=horizontal]>div]:rotate-90', className)} {...props}>
      {withHandle && (<div className="bg-background border-border group-hover:border-primary/60 group-hover:bg-primary/10 z-10 flex h-7 w-3 shrink-0 items-center justify-center rounded-sm border transition-colors">
          <GripVertical className="text-muted-foreground group-hover:text-primary size-2.5" aria-hidden/>
        </div>)}
    </ResizablePrimitive.Separator>);
}
export { ResizableHandle, ResizablePanel, ResizablePanelGroup };
export { usePanelRef } from 'react-resizable-panels';
